import { EntityType } from 'features/config/Entities';
import { ConfigDescriptor } from 'features/config/feature-configs/ConfigDescriptor';
import { percentage_change_num } from 'helpers/percentage_change';
import { entityList, entityListExtra } from 'interfaces/generic-entity.interface';

//TODO: MOVE TO BACKEND
type operator = 'gt' | 'gte' | 'lt' | 'lte' | 'eq' | 'ne';

const comparisonFunctions: Record<operator, (a: number, b: number) => boolean> = {
    gt: (a, b) => a > b,
    gte: (a, b) => a >= b,
    lt: (a, b) => a < b,
    lte: (a, b) => a <= b,
    eq: (a, b) => a === b,
    ne: (a, b) => a !== b,
};

function entityListExtraProvider(
    entityList: entityList[],
    entityType: EntityType
): entityListExtra[] {
    const entityConfig = ConfigDescriptor.getEntityConfig(entityType);

    if (!entityConfig) {
        throw new Error(`Entity configuration for type not found.`);
    }

    const catalogueConfig = entityConfig.entityCatalogueConfig;

    if (
        !catalogueConfig ||
        !catalogueConfig.filterConfig ||
        !catalogueConfig.filterConfig.operator ||
        !catalogueConfig.filterConfig.operand ||
        catalogueConfig.filterConfig.filterLimit === undefined
    ) {
        throw new Error(`Catalogue configuration for entity type is missing or incomplete.`);
    }

    const operator: operator = catalogueConfig.filterConfig.operator;
    const operand: string = catalogueConfig.filterConfig.operand;
    const limit = catalogueConfig.filterConfig.filterLimit;

    const converted_data: entityListExtra[] = entityList
        .filter((entry) => {
            // Ensure the operand exists in the entry and is a number
            const value = entry[operand as keyof entityList];
            const numericValue = (typeof value === 'number' ? value : Number(value)) || 0;
            if (comparisonFunctions[operator](numericValue, limit)) return true;
            else return false;
        })
        .map((entry) => {
            return {
                ...entry,
                // Calculate with potential nulls replaced by 0
                change_abs: (entry.last_month || 0) - (entry.two_months_ago || 0),
                change_rel: percentage_change_num(entry.two_months_ago || 0, entry.last_month || 0),
                available: true,
            };
        });
    return converted_data;
}

export default entityListExtraProvider;
